import { BaseComponent } from 'components/BaseComponent';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { changeHistoryFilter } from '../actions';
import { FILTER_DEFAULT_LIMIT } from '../constants';
import { selectEmailHistoryCount, selectEmailHistoryFilter } from '../selector';

const Container = styled.div`
  .page {
    margin: 6px;
    &:hover {
      font-weight: bold;
      cursor: pointer;
    }
    .is-current {
      font-weight: bold;
    }
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class EmailHistoryOverviewPaginationComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  get limit() {
    return this.props.filter?.limit || FILTER_DEFAULT_LIMIT;
  }

  get count() {
    return this.props.count || 0;
  }

  get offset() {
    return this.props.filter?.offset || 0;
  }

  get pages() {
    return this.count ? Math.ceil(this.count / this.limit) : 0;
  }

  get page() {
    return Math.floor(this.offset / this.limit);
  }

  render() {
    if (!this.props.filter) return null;

    return (
      <Container>
        <HBox center>{_.times(Math.min(50, this.pages), this.renderPage.bind(this))}</HBox>
      </Container>
    );
  }

  renderPage(num) {
    return (
      <div
        key={num}
        className={`page page-${num} ${num == this.page ? ' is-current' : ''}`}
        onClick={() => this.props.toOffset(num * this.limit)}
      >
        {num}
      </div>
    );
  }
}

EmailHistoryOverviewPaginationComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectEmailHistoryFilter(),
    count: selectEmailHistoryCount(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    toOffset(offset) {
      dispatch(changeHistoryFilter('offset', offset));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const EmailHistoryOverviewPagination = compose(
  withConnect,
  withRouter,
)(EmailHistoryOverviewPaginationComp);
